export const INDUCTION_MESSAGE_STATUS = {
  SEND: "SEND",
  RESEND: "RESEND",
  BULK: "BULK"
};
